// Barrel de @rema/shared — contratos, constantes y tipos compartidos (Fase 1C).
export * from "./audit-events"
export * from "./error-codes"
export * from "./identifier"
export * from "./jwt"
export * from "./schemas/app-keys"
export * from "./schemas/audit"
export * from "./schemas/auth"
export * from "./schemas/branding"
export * from "./schemas/clients"
export * from "./schemas/common"
export * from "./schemas/domains"
export * from "./schemas/me"
export * from "./schemas/metrics"
export * from "./schemas/nodes"
export * from "./schemas/roles"
export * from "./schemas/settings"
export * from "./schemas/users"
export * from "./schemas/vehicles"
export * from "./schemas/webhooks"
export * from "./scopes"
